/**
 * 右侧排行面板。
 *
 * 支持切换排序维度：健康度 / 逾期 / 达标率。
 * 全国视图排行省份；下钻到省后排行该省项目。
 */

export type RankMode = 'health' | 'overdue' | 'pass';

export interface RankRow {
  key: string;
  name: string;
  /** 用于画条形图的数值 */
  value: number;
  /** 展示值（可为 '—'） */
  display: string;
  color: string;
  sub: string;
}

export interface ProvinceRankProps {
  title: string;
  mode: RankMode;
  onModeChange: (mode: RankMode) => void;
  rows: readonly RankRow[];
  onRowClick: (key: string) => void;
}

const MODES: ReadonlyArray<{ key: RankMode; label: string }> = [
  { key: 'health', label: '健康度' },
  { key: 'overdue', label: '逾期' },
  { key: 'pass', label: '达标率' },
];

export default function ProvinceRank({
  title,
  mode,
  onModeChange,
  rows,
  onRowClick,
}: ProvinceRankProps) {
  const max = Math.max(...rows.map((r) => r.value), 1);

  return (
    <div className="map-rank">
      <div className="rh">
        <span className="ti">{title}</span>
        <span className="sw">
          {MODES.map((m) => (
            <span
              key={m.key}
              className={mode === m.key ? 'on' : ''}
              onClick={() => onModeChange(m.key)}
              role="button"
              tabIndex={0}
            >
              {m.label}
            </span>
          ))}
        </span>
      </div>
      <div className="rb">
        {rows.length === 0 ? (
          <div className="rrow rrow--empty">暂无数据</div>
        ) : (
          rows.map((r, i) => (
            <div key={r.key} className="rrow" onClick={() => onRowClick(r.key)}>
              <span className="ri">{i + 1}</span>
              <span className="rn" title={`${r.name}（${r.sub}）`}>
                {r.name}
              </span>
              <span className="rbar">
                <i style={{ width: `${Math.max(4, (r.value / max) * 100)}%`, background: r.color }} />
              </span>
              <span className="rv" style={{ color: r.color }}>
                {r.display}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
